import React from 'react';
import { isEmpty, merge } from 'lodash';
import { useIntl } from 'react-intl';
import TextInput from 'app/commonComponents/molecules/textInput';
import genericErrorHandler from 'app/utils/serverErrors';
import { ajaxRequest } from 'app/utils/helpers';
import { showError } from 'app/globalMessages/globalMessagesClient';
import WaitingListCheckboxGroup from './waitingListCheckboxGroup';
import './waiting-list-component.scss';

const { componentData, waitingListURL } = window.waitingList;
const { cta, sites, confirmationPageUrl } = componentData;

const WaitingListComponent = props => {
  const intl = useIntl();
  const { values, setValues, errors: formErrors, setTouched, setErrors } = props;
  const { emailSubscription: emailSubscriptionEnabled } = values;

  const onSubmit = e => {
    e.preventDefault();
    const { email, emailSubscription, interestId, site } = values;
    const { submitForm } = props;

    submitForm().then(response => {
      const { errors } = response;

      if (!isEmpty(errors)) {
        return;
      }

      ajaxRequest('POST', waitingListURL, { email, emailSubscription, interestId, site }).then(
        res => {
          if (res.status === 'success') {
            window.location.href = confirmationPageUrl;
            return;
          }
          showError({ message: res.message, autoHide: true });
        },
        ({ status }) => genericErrorHandler(status)
      );
    });
  };

  const onSitesChange = siteSelected => {
    const newValues = { ...values };
    newValues.site = siteSelected;
    setValues(newValues);
  };

  return (
    <div>
      <form className="waiting-list" onSubmit={onSubmit}>
        {sites && sites.length > 0 && (
          <fieldset className="form-input form-input--checkboxes">
            <div className="waiting-list__sites">
              <WaitingListCheckboxGroup sites={sites} onChange={onSitesChange} checked={values.site} />
            </div>
            <span className="waiting-list__sites-error form-msg-error" role="alert">
              {' '}
              {formErrors.site}{' '}
            </span>
          </fieldset>
        )}
        <fieldset className="form-input waiting-list__email-wrapper">
          <TextInput
            id="email"
            name="email"
            labelText=""
            placeholder={intl.formatMessage({
              id: 'footer.subscription.email.placeholder',
            })}
            // ToDo: This is a patch to fix an error that is just able to reproduce in production: HYB-1791
            // we are having this same behavior in the email subscription in the footer and in the some new fields
            // like dniTextInput.js, we need to go deeper in this problem, and looks like it's related to the onBlur
            onBlur={() => {
              if (!isEmpty(values.email)) {
                setTouched(merge({}, { email: true }));
              }
              setErrors(merge({}, formErrors));
            }}
          />
          <button
            style={{ background: cta.background.code }}
            type="button"
            className="button waiting-list__register-btn"
            onClick={onSubmit}
          >
            {cta.text}
          </button>
        </fieldset>
        {emailSubscriptionEnabled && (
          <p dangerouslySetInnerHTML={{ __html: intl.formatMessage({ id: 'waitingList.legend.text' }) }} />
        )}
      </form>
    </div>
  );
};

WaitingListComponent.propTypes = {};

export default WaitingListComponent;
